import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
import { functionWithCondition } from '@jira/platform__utils-feature-flagging-utils/src/utils/function-with-condition/index.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import { useApplicationPermissions } from '@atlassian/jira-tenant-context-controller/src/components/application-permissions/index.tsx';
import { useIsJsmOnly } from './useIsJsmOnly.tsx';
import { useIsJsmRoute } from './useIsJsmRoute.tsx';
import { useIsWorkforceOrLiveChatEnabled } from './useIsWorkforceOrLiveChatEnabled.tsx';

const useIsEligibleForWorkforceAvailabilityBadgeEnabled = (): boolean => {
	const isJsmOnly = useIsJsmOnly();
	const isJsmRoute = useIsJsmRoute();
	const { hasServiceDeskAccess } = useApplicationPermissions();
	const isWorkforceOrLiveChatEnabled = useIsWorkforceOrLiveChatEnabled();

	return (
		isJsmOnly &&
		isJsmRoute &&
		hasServiceDeskAccess &&
		isWorkforceOrLiveChatEnabled &&
		expVal('jsm_workforce_optimization_status_control', 'isEnabled', false)
	);
};

export const useIsEligibleForWorkforceAvailabilityBadge: () => boolean = functionWithCondition(
	() =>
		isFeatureEnabled('jira-service-management', 'jsm-workforce') &&
		fg('jsm_workforce_optimization_main'),
	useIsEligibleForWorkforceAvailabilityBadgeEnabled,
	() => false,
);
